function intlFormat(inputNum: number) {
  return new Intl.NumberFormat().format(Math.round(inputNum * 10) / 10);
}

export const formatNumber = (num: number | string) => {
  let inputNum: number;
  if (typeof num === 'string') {
    inputNum = parseInt(num.toString(), 10);
  } else {
    inputNum = num;
  }

  if (inputNum >= 1000000) return `${intlFormat(inputNum / 1000000)}M`;
  if (inputNum >= 1000) return `${intlFormat(inputNum / 1000)}K`;
  return intlFormat(inputNum);
};
